module.exports = __webpack_public_path__ + "static/media/pastOrder.94941f8a.png";